/**
 * Numbering follows the boxes on the ICS 204A-CG Assignment List Attachment
 * form. Boxes 1–3 and 12–14 are read-only; 4–10 are editable planned-resource
 * fields. Box 11 is omitted (blank strip on the paper form).
 */
export const ICS204A_BOX_LABELS = {
  incidentName: '1. Incident Name:',
  incidentLocation: '2. Incident Location:',
  operationalPeriod: '3. Operational Period (Date/Time):',
  branch: '4. Branch:',
  divisionGroup: '5. Division/Group:',
  strikeTeamTaskForceResource: '6. Strike Team / Task Force / Resource:',
  leader: '7. Leader:',
  assignmentLocation: '8. Assignment Location:',
  specialInstructions:
    '9. Work Assignment Special Instructions, Special Equipment / Supplies Needed for Assignment, Special Environmental Considerations; Special Site-Specific Safety Considerations:',
  siteSafetyPlan: '10. Site Safety Plan located at:',
  preparedBy: '12. Prepared by:',
  reviewedByPsc: '13. Reviewed by (PSC):',
  reviewedByOsc: '14. Reviewed by (OSC/ISC):',
} as const;

/** Full official Box 9 wording shown as a muted hint under the short title. */
export const ICS204A_SPECIAL_INSTRUCTIONS_HINT =
  'Special Equipment / Supplies Needed for Assignment, Special Environmental Considerations; Special Site-Specific Safety Considerations';
